import { SimpleSelectOptionType } from '@epicuro-next/features/landing-panel';
import { IDynamicBindableValue } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { getIdProvider } from '../../../../utils/dynamic-items-utils';
import { dayRangeSelectOptions } from './day-range-select-options';

const defaultSelectedDayIndex = 0;
const defaultSelectedDayOption: SimpleSelectOptionType =
  dayRangeSelectOptions[defaultSelectedDayIndex];

export const daysIntoTheFutureProvider: IDynamicBindableValue = {
  ...getIdProvider('products-on-the-way-day-range-select', 'selectionChanged'),
  startWith: {
    value: defaultSelectedDayOption,
  },
  transform: function (option: SimpleSelectOptionType): string {
    return option.value;
  }.toString(),
};

export const shipToAddressIdProvider: IDynamicBindableValue = {
  ...getIdProvider('filter-by-ship-to-select', 'selectionChanged'),
  startWith: {
    value: {
      value: undefined,
    },
  },
  transform: function (option: SimpleSelectOptionType): string | undefined {
    return option.value;
  }.toString(),
};
